import { ResponseBody } from '../types/common';
import {
  CancelInfo,
  DeletionSchedule,
  MembershipInfo,
  Payment,
  PaymentHistoryInfo,
  PaymentInfo,
  Price,
} from '../types/membership';
import { apiSlice } from './api';

export const membershipApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getMembership: builder.query<any, void>({
      query: () => ({
        url: 'library/mgmt/membership',
      }),
      transformResponse: (res: ResponseBody) => res.data,
    }),
    getMembershipList: builder.query<MembershipInfo, void>({
      query: () => ({
        url: 'library/mgmt/membership/list',
      }),
      transformResponse: (res: ResponseBody) => res.data,
    }),
    submitMembershipInquiry: builder.mutation({
      query: ({ title, content }) => ({
        url: 'library/mgmt/qna/enterprise',
        method: 'POST',
        body: { data: { title, content } },
      }),
      transformResponse: (res: ResponseBody) => res.data,
    }),
    getStorageRemovalList: builder.query<DeletionSchedule, void>({
      query: () => ({
        url: 'library/mgmt/storage/remove',
      }),
      transformResponse: (res: ResponseBody) => res.data,
    }),
    getPayment: builder.query<Payment, { membershipId: number }>({
      query: ({ membershipId }) => ({
        url: 'library/mgmt/membership/payment',
        params: { membershipId },
      }),
      transformResponse: (res: ResponseBody) => res.data,
    }),
    getPaymentPrice: builder.query<
      Price,
      { membershipId: number; capacityStudent: number }
    >({
      query: ({ membershipId, capacityStudent }) => ({
        url: 'library/mgmt/membership/payment/price',
        params: { membershipId, capacityStudent },
      }),
      transformResponse: (res: ResponseBody) => res.data,
    }),
    getPaymentAdditionalPersonnel: builder.query<Payment, void>({
      query: () => ({
        url: 'library/mgmt/membership/payment/student',
      }),
      transformResponse: (res: ResponseBody) => res.data,
    }),
    submitPayment: builder.mutation({
      query: ({ membershipInfo, student, aitool, paymentInfo }) => ({
        url: 'library/mgmt/membership/payment',
        method: 'POST',
        body: { data: { membershipInfo, student, aitool, paymentInfo } },
      }),
      transformResponse: (res: ResponseBody) => res.data,
    }),
    submitPaymentAdditionalPersonnel: builder.mutation({
      query: ({ paymentInfo, student }) => ({
        url: 'library/mgmt/membership/payment/student',
        method: 'POST',
        body: { data: { paymentInfo, student } },
      }),
      transformResponse: (res: ResponseBody) => res.data,
    }),
    getMembershipCancel: builder.query<CancelInfo, void>({
      query: () => ({
        url: 'library/mgmt/membership/unsubscribe/init',
      }),
      transformResponse: (res: ResponseBody) => res.data,
    }),
    cancelMembership: builder.mutation({
      query: ({ cdList, reason }) => ({
        url: 'library/mgmt/membership/unsubscribe',
        method: 'POST',
        body: { data: { cdList, reason } },
      }),
      transformResponse: (res: ResponseBody) => res.data,
    }),
    getPaymentInfo: builder.query<PaymentInfo, void>({
      query: () => ({
        url: 'library/mgmt/membership/payment/info',
      }),
      transformResponse: (res: ResponseBody) => res.data,
    }),
    submitPaymentInfo: builder.mutation({
      query: (paymentInfo) => ({
        url: 'library/mgmt/membership/payment/info',
        method: 'PUT',
        body: { data: { ...paymentInfo } },
      }),
      transformResponse: (res: ResponseBody) => res.data,
    }),
    getPaymentHistory: builder.query<PaymentHistoryInfo[], void>({
      query: () => ({
        url: 'library/mgmt/membership/payment/history',
      }),
      transformResponse: (res: ResponseBody) => res.data,
    }),
  }),
});

export const {
  useGetMembershipQuery,
  useGetMembershipListQuery,
  useSubmitMembershipInquiryMutation,
  useGetStorageRemovalListQuery,
  useGetPaymentQuery,
  useGetPaymentPriceQuery,
  useGetPaymentAdditionalPersonnelQuery,
  useSubmitPaymentMutation,
  useSubmitPaymentAdditionalPersonnelMutation,
  useGetMembershipCancelQuery,
  useCancelMembershipMutation,
  useGetPaymentInfoQuery,
  useSubmitPaymentInfoMutation,
  useGetPaymentHistoryQuery,
} = membershipApiSlice;
